module.exports = __webpack_public_path__ + "img/check.007e9b2e.svg";